import React from "react";
import {
  formatScheduleListDate,
  formatShortScheduleListDate,
} from "../../../helpers/dateFormatter";
import {
  convertTo12HourFormat,
  formatTimeSlots,
} from "../../../helpers/timeFormatter";
import { Icon } from "@iconify/react/dist/iconify.js";
import pendingIcon from "../../../assets/pending-icon.png";
import cancelledIcon from "../../../assets/cancelled-icon.png";
import confirmedIcon from "../../../assets/confirmed-icon.png";
function BDTitleDetails({ bookingDetails }) {
  return (
    <div className="bd-p-header d-flex flex-lg-row gap-lg-0 gap-3 flex-column justify-content-between align-items-center mb-3">
      <div className="col-lg-6 col-12">
        <h4 className="bd-p-header-title">
          {bookingDetails?.product_title}
          <span className="bd-p-header-booking-id">
            {" "}
            {bookingDetails?.voucher_number}
          </span>
        </h4>
        <p className="bd-p-header-date m-0 p-0">
          Booked on: {formatShortScheduleListDate(bookingDetails?.booked_date)},{" "}
          {convertTo12HourFormat(bookingDetails?.booked_date)}
        </p>
      </div>
      <div className="bd-p-header-status col-lg-6 col-12 d-flex flex-column align-items-end gap-lg-3 gap-2 justify-content-between">
        {bookingDetails?.order_status?.toLowerCase() === "completed" && (
          <div className="badge bd-badge-confirmed">
            <img
              src={confirmedIcon}
              alt="pending icon"
              width={16}
              height={16}
              className="me-2"
            />
            {bookingDetails?.order_status}
          </div>
        )}
        {bookingDetails?.order_status?.toLowerCase() === "canceled" && (
          <div className="badge bd-badge-cancelled">
            <img
              src={cancelledIcon}
              alt="pending icon"
              width={16}
              height={16}
              className="me-2"
            />
            {bookingDetails?.order_status}
          </div>
        )}

        {bookingDetails?.order_status?.toLowerCase() === "in process" && (
          <div className="badge bd-badge-pending d-flex align-items-center gap-2">
            <img src={pendingIcon} alt="pending icon" width={16} height={16} />
            Pending
          </div>
        )}
        <p className="bd-p-header-date bd-p-header-date-bold d-flex align-items-center m-0 p-0">
          <Icon
            icon="ic:twotone-calendar-month"
            color="#EB662B"
            fontSize={22}
            className="me-1"
          />
          {formatScheduleListDate(bookingDetails?.trip_date)}
        </p>
      </div>
    </div>
  );
}

export default BDTitleDetails;
